module.exports = __webpack_public_path__ + "img/capricciosa.6eeecaf3.jpg";